import React from 'react';

import UploadInput from '~components/generic/elements/Upload/UploadInput';
import styles from './UploadWrapper.module.css';

interface UploadWrapperProps {
  allowedFormats: string[];
  onUpload: any;
}

const UploadWrapper: React.FC<UploadWrapperProps> = ({ allowedFormats, onUpload }) => {
  return (
    <UploadInput
      overlayContentClassName={styles.overlayContent}
      containerClassName={styles.containerClassName}
      onUpload={onUpload}
      multiple={true}
      allowedFormats={allowedFormats}
    />
  );
};

export default UploadWrapper;
